import * as React from 'react';

import {
  AudienceInterestsCard,
  CityStateCard,
  CountryCard,
  EngagementRateCard,
  GenderAgeCard,
  LanguageEthnicityCard,
  PostPerformanceCard,
  ProfileCard,
  SummaryCard,
  GrowthCard,
} from '../Card';
import { useSocialProfileContext } from '../hooks/useSocialProfileContext';
import { Tab } from '../models';

import styles from './Content.scss';

export const InstagramContent: React.FC = () => {
  const { activeTab } = useSocialProfileContext();

  return <>
    {(!activeTab || activeTab === Tab.SUMMARY) && (
      <div className={styles.summary}>
        <ProfileCard className={styles.ProfileCard} />
        <EngagementRateCard className={styles.EngagementRateCard} />
        <SummaryCard className={styles.SummaryCard} />
      </div>
    )}
    {activeTab === Tab.ANALYZE && (
      <div className={styles.analyze}>
        <GenderAgeCard className={styles.GenderAgeCard} />
        <AudienceInterestsCard className={styles.AudienceInterestsCard} />
        <LanguageEthnicityCard className={styles.LanguageEthnicityCard} />
        <CountryCard className={styles.CountryCard} />
        <CityStateCard className={styles.CityStateCard} />
        <PostPerformanceCard className={styles.PostPerformanceCard} />
        <GrowthCard className={styles.GrowthCard} />
      </div>
    )}
  </>;
};
